<template>
  <div class="order-operation-wrapper">
    <van-nav-bar
      title="蒙牛广州经销商"
    />
    <van-tabs v-model="active">
      <van-tab title="待发货" name="待发货">
        <div class="wait" v-if="wait.length > 0">
          <van-card
            :num="item.num"
            :price="item.price"
            :title="item.title"
            :thumb="item.imgUrl"
            v-for="(item, index) in wait"
            :desc="item.resTime"
            :key="index"
          >
            <template #bottom>
              <div class="address">
                <div>{{item.addressName}} {{item.addressTel}}</div>
                <div>{{item.address}}</div>
              </div>
              <div class="car-msg">
                共{{item.num}}件商品，合计{{(item.price * item.num).toFixed(2)}}
              </div>
            </template>
            <template #footer>
              <van-button size="small" @click="changeStatus(item.id, 2)" round>取消订单</van-button>
              <van-button size="small" @click="changeStatus(item.id, 1)" type="info" round>确认发货</van-button>
            </template>
          </van-card>
          <van-divider>
            到底啦
          </van-divider>
        </div>
        <div v-else class="no-msg">
          <van-divider>
            暂时没有待发货的订单哦
          </van-divider>
        </div>
      </van-tab>
      <van-tab title="已发货" name="已发货">
        <div class="wait" v-if="already.length > 0">
          <van-card
            :num="item.num"
            :price="item.price"
            :title="item.title"
            :thumb="item.imgUrl"
            v-for="(item, index) in already"
            :key="index"
            :desc="item.time"
          >
            <template #bottom>
              <div class="msg">
                <div>物流单号：{{item.logistics}}</div>
                <div>备注：{{item.remarks}}</div>
              </div>
              <div class="address">
                <div>{{item.addressName}} {{item.addressTel}}</div>
                <div>{{item.address}}</div>
              </div>
              <div class="car-msg">
                共{{item.num}}件商品，合计{{(item.price * item.num).toFixed(2)}}
              </div>
            </template>
            <template #footer>
            </template>
          </van-card>
          <van-divider>
            到底啦
          </van-divider>
        </div>
        <div v-else class="no-msg">
          <van-divider>
            暂时没有已发货的订单哦
          </van-divider>
        </div>
      </van-tab>
      <van-tab title="已取消" name="已取消">
        <div class="wait" v-if="cancel.length > 0">
          <van-card
            :num="item.num"
            :price="item.price"
            :title="item.title"
            :thumb="item.imgUrl"
            v-for="(item, index) in cancel"
            :key="index"
            :desc="item.time"
          >
            <template #bottom>
              <div class="msg">
                <div >备注：{{item.remarks}}</div>
              </div>
              <div class="address">
                <div>{{item.addressName}} {{item.addressTel}}</div>
                <div>{{item.address}}</div>
              </div>
              <div class="car-msg">
                共{{item.num}}件商品，合计{{(item.price * item.num).toFixed(2)}}
              </div>
            </template>
            <template #footer>
            </template>
          </van-card>
          <van-divider>
            到底啦
          </van-divider>
        </div>
        <div v-else class="no-msg">
          <van-divider>
            暂时没有已取消的订单哦
          </van-divider>
        </div>
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="show"
      :title="contentsatNum === 1 ? '是否确认发货？' : '是否取消订单？'"
      show-cancel-button
      @confirm="clickTrue"
    >
      <div class="dialog-input">
        <van-field v-model="remarks" label="备注" />
        <van-field v-model="logistics" label="物流单号" v-if="contentsatNum === 1" />
      </div>
    </van-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      active: '待发货',
      wait: [],
      already: [],
      cancel: [],
      testData: [],
      content: [
        {
          title: '每日鲜语鲜牛奶250ml*12蒙牛巴氏杀菌鲜牛奶每日鲜奶配送鲜牛奶',
          imgUrl: require('@/assets/imgs/1.jpg'),
          price: 63.9,
          num: 2,
          status: 0,
          id: 0,
          address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室',
          addressName: '张三',
          addressTel: 13000000000,
          resTime: '2020-03-20'
        },
        {
          title: '每日鲜语鲜牛奶1L*3蒙牛鲜牛奶每日鲜奶配送巴氏杀菌鲜牛奶低温奶',
          imgUrl: require('@/assets/imgs/2.jpg'),
          price: 79.9,
          num: 1,
          status: 0,
          id: 1,
          address: '浙江省杭州市拱墅区莫干山路 50 号',
          addressName: '李四',
          addressTel: 13000000000,
          resTime: '2020-03-20'
        },
        {
          title: '每日鲜语冷萃咖啡拿铁250ml咖啡牛奶瓶装即饮奶香提神咖啡冷粹',
          imgUrl: require('@/assets/imgs/3.jpg'),
          price: 63.9,
          num: 10,
          status: 0,
          id: 2,
          address: '浙江省杭州市拱墅区莫干山路 50 号',
          addressName: '王二',
          addressTel: 13000000000,
          resTime: '2020-03-20'
        },
        {
          title: '每日鲜语鲜牛奶冷萃咖啡拿铁250ml*12鲜奶配送牛奶巴氏杀菌鲜牛奶',
          imgUrl: require('@/assets/imgs/4.jpg'),
          price: 102.9,
          num: 1,
          status: 0,
          id: 3,
          address: '浙江省杭州市拱墅区莫干山路 50 号',
          addressName: '王二',
          addressTel: 13000000000,
          resTime: '2020-03-20'
        },
        {
          title: '每日鲜语鲜牛奶250ml*48蒙牛鲜牛奶巴氏杀菌鲜牛奶早餐奶全脂牛奶',
          imgUrl: require('@/assets/imgs/5.jpg'),
          price: 349.9,
          num: 3,
          status: 0,
          id: 4,
          address: '浙江省杭州市拱墅区莫干山路 50 号',
          addressName: '王二',
          addressTel: 13000000000,
          resTime: '2020-03-20'
        },
        {
          title: '每日鲜语鲜牛奶1L*12蒙牛鲜牛奶巴氏杀菌鲜牛奶早餐奶全脂牛奶',
          imgUrl: require('@/assets/imgs/6.jpg'),
          price: 291.9,
          num: 4,
          status: 0,
          id: 5,
          address: '浙江省杭州市拱墅区莫干山路 50 号',
          addressName: '王二',
          addressTel: 13000000000,
          resTime: '2020-03-20'
        }
      ],
      show: false,
      contentIndex: Number,
      contentsatNum: Number,
      remarks: '',
      logistics: ''
    }
  },

  mounted () {
    this.resData()
    this.test()
  },

  methods: {
    resData () {
      // 处理本地数据
      // localStorage.removeItem("testDataT")
      if(!localStorage.getItem('testDataT')) {
        localStorage.setItem('testDataT', JSON.stringify(this.content))
        this.testData = this.content
      } else {
        this.testData = JSON.parse(localStorage.getItem('testDataT'))
      }
    },
    test () {
      this.wait = this.testData.filter(item => item.status === 0)
      this.already = this.testData.filter(item => item.status === 1)
      this.cancel = this.testData.filter(item => item.status === 2)
      localStorage.setItem('testDataT', JSON.stringify(this.testData))
    },
    changeStatus (index, satNum) {
      this.remarks = ''
      this.logistics = ''
      this.contentIndex = index
      this.contentsatNum = satNum
      this.show = true
    },
    clickTrue () {
      var time = new Date()
      this.testData[this.contentIndex].status = this.contentsatNum
      this.testData[this.contentIndex].time = this.formatDate(time)
      this.testData[this.contentIndex].remarks = this.remarks
      this.testData[this.contentIndex].logistics = this.logistics
      this.test()
      this.$notify({
        message: this.contentsatNum === 1 ? '确认发货成功，请在已发货中查看' : '取消成功，请在已取消中查看',
        color: '#fff',
        background: 'rgb(25, 137, 250)',
        duration: 1500
      })
    },
    formatDate (date) {
      var myyear = date.getFullYear()
      var mymonth = date.getMonth() + 1
      var myweekday = date.getDate()
      if (mymonth < 10) {
          mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
          myweekday = '0' + myweekday
      }
      return (myyear + '-' + mymonth + '-' + myweekday)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-operation-wrapper {
  width: 375px;
  min-height: 100vh;
  background: #fff;
  .no-msg {
    margin-top: 30px;
  }
  .address {
    width: 80%;
    margin: 10px 0;
    &>div:nth-child(1) {
      font-size: 14px;
      line-height: 18px;
      color: rgb(50, 50, 51);
    }
    &>div:nth-child(2) {
      color: #323233;
      line-height: 14px;
      margin-top: 5px;
    }
  }
  .car-msg {
    display: flex;
    justify-content: flex-end;
    color: #333;
    font-size: 12px;
    border-top: 1px solid #f2f2f2;
    padding-top: 10px;
  }
}
</style>
